"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var guid_typescript_1 = require("guid-typescript");
var ts_promise_1 = require("ts-promise");
var AppBridgeStatusCode;
(function (AppBridgeStatusCode) {
    AppBridgeStatusCode[AppBridgeStatusCode["EmptyResponse"] = 2] = "EmptyResponse";
    AppBridgeStatusCode[AppBridgeStatusCode["Ok"] = 1] = "Ok";
    AppBridgeStatusCode[AppBridgeStatusCode["MethodNotKnown"] = -1] = "MethodNotKnown";
    AppBridgeStatusCode[AppBridgeStatusCode["MethodDoesNotAcceptData"] = -2] = "MethodDoesNotAcceptData";
    AppBridgeStatusCode[AppBridgeStatusCode["NoBridgeMethodResponse"] = -3] = "NoBridgeMethodResponse";
    AppBridgeStatusCode[AppBridgeStatusCode["ResponseSerializationFailed"] = -4] = "ResponseSerializationFailed";
    AppBridgeStatusCode[AppBridgeStatusCode["RequestDeserializationFailed"] = -5] = "RequestDeserializationFailed";
    AppBridgeStatusCode[AppBridgeStatusCode["NativeMethodInvocationFailed"] = -6] = "NativeMethodInvocationFailed";
    AppBridgeStatusCode[AppBridgeStatusCode["MethodArgumentConvertFailed"] = -7] = "MethodArgumentConvertFailed";
    AppBridgeStatusCode[AppBridgeStatusCode["RequestedDataNotFound"] = -8] = "RequestedDataNotFound";
    AppBridgeStatusCode[AppBridgeStatusCode["SecureStoreUnavailable"] = -9] = "SecureStoreUnavailable";
    AppBridgeStatusCode[AppBridgeStatusCode["RequestDataIncomplete"] = -10] = "RequestDataIncomplete";
})(AppBridgeStatusCode = exports.AppBridgeStatusCode || (exports.AppBridgeStatusCode = {}));
var boldGreen = 'color:#228B22; font-weight: bold;';
var regular = 'color:#000; font-weight: normal;';
var XamAppBridge = /** @class */ (function () {
    function XamAppBridge() {
        this.opPromises = {};
        this.networkStateChangeCallback = null;
        this.keyboardStateChangeCallback = null;
        this.appDidResumeCallback = null;
        this.isAndroid = typeof Android != 'undefined' && typeof Android.bridgeInvoke != 'undefined';
        this.isIos = typeof webkit != 'undefined' && typeof webkit.messageHandlers.bridgeInvoke != 'undefined';
        if (XamAppBridge.debugEnabled)
            console.log('%c[AppBridge]' + '%c created, isAndroid: ' + this.isAndroid + ', isIos: ' + this.isIos, boldGreen, regular);
    }
    XamAppBridge.prototype.appDidResume = function (newPort) {
        console.log("[AppBridge] app did resume on port " + newPort);
        if (this.appDidResumeCallback != null) {
            this.appDidResumeCallback(newPort);
        }
    };
    XamAppBridge.prototype.appExtHideSplashImage = function () {
        return this.bridgeCallNativeInternal('AppExtHideSplashImage', null);
    };
    XamAppBridge.prototype.bridgeCallNativeInternal = function (fnName, data) {
        var _this = this;
        if (!this.isMobileWithBridge()) {
            if (XamAppBridge.debugEnabled)
                console.log("%c[AppBridge]%c not in a container environment", boldGreen, regular);
            return ts_promise_1.Promise.reject(new Error('not in a container environment'));
        }
        var guid;
        do {
            guid = guid_typescript_1.Guid.create().toString();
        } while (this.opPromises[guid]);
        var packedData = null;
        var jsonString = null;
        if (data != null) {
            jsonString = (JSON.stringify(data));
            packedData = btoa(encodeURIComponent(jsonString));
        }
        if (XamAppBridge.debugEnabled)
            console.log("%c[AppBridge]%c -> (" + guid + ") " + fnName + " ; data: " + jsonString + " (" + packedData + ")", boldGreen, regular);
        return new ts_promise_1.Promise(function (resolve, reject) {
            _this.opPromises[guid] = { resolve: resolve, reject: reject };
            if (_this.isAndroid) {
                Android.bridgeInvoke(guid, fnName, packedData);
            }
            else if (_this.isIos) {
                webkit.messageHandlers.bridgeInvoke.postMessage({ id: guid, fn: fnName, data: packedData });
            }
        });
    };
    XamAppBridge.prototype.bridgeKeyboardStateChange = function (doesShow) {
        if (this.keyboardStateChangeCallback != null) {
            this.keyboardStateChangeCallback(doesShow);
        }
    };
    XamAppBridge.prototype.bridgeNativeCallback = function (id, success, statusCode, hasData, packedData) {
        var promise = this.opPromises[id.toString()];
        if (promise == null) {
            if (hasData && XamAppBridge.debugEnabled)
                console.log("no promise found for " + id);
            return;
        }
        var jsonString = null;
        var data;
        if (hasData && packedData) {
            jsonString = packedData ? decodeURIComponent(atob(packedData)) : null;
            var decoded = jsonString != null ? JSON.parse(jsonString) : null;
            data = { status: statusCode, data: decoded };
        }
        else {
            data = { status: statusCode, data: null };
        }
        if (XamAppBridge.debugEnabled)
            console.log("%c[AppBridge]%c <- (" + id.toString() + ") success: " + success + " ; hasData: " + hasData + " ; data: " + jsonString + " (" + packedData + ")", boldGreen, regular);
        delete this.opPromises[id.toString()];
        if (success) {
            promise.resolve(data);
        }
        else {
            promise.reject(data);
        }
    };
    XamAppBridge.prototype.bridgeNetworkStateChanged = function (hasInternet) {
        if (this.networkStateChangeCallback != null) {
            this.networkStateChangeCallback(hasInternet);
        }
    };
    XamAppBridge.prototype.getNetworkState = function () {
        return this.bridgeCallNativeInternal('GetNetworkState', null);
    };
    XamAppBridge.prototype.isMobileWithBridge = function () {
        return this.isAndroid || this.isIos;
    };
    XamAppBridge.prototype.logToConsole = function (text) {
        console.log("[AppHost] " + text);
    };
    XamAppBridge.prototype.nativePing = function (pingValue) {
        return this.bridgeCallNativeInternal('Ping', { ping_value: pingValue });
    };
    XamAppBridge.prototype.openBrowserForUrl = function (url) {
        return this.bridgeCallNativeInternal('OpenBrowserForUrl', { url: url });
    };
    XamAppBridge.prototype.registerAppDidResumeCallback = function (callback) {
        this.appDidResumeCallback = callback;
    };
    XamAppBridge.prototype.registerKeyboardStateChangeCallback = function (callback) {
        this.keyboardStateChangeCallback = callback;
    };
    XamAppBridge.prototype.registerNetworkStateChangeCallback = function (callback) {
        this.networkStateChangeCallback = callback;
    };
    XamAppBridge.prototype.secureStoreDelete = function (key) {
        if (key === void 0) { key = null; }
        return this.bridgeCallNativeInternal('SecureStoreDelete', { key: key });
    };
    XamAppBridge.prototype.secureStoreLoad = function (key) {
        if (key === void 0) { key = null; }
        return this.bridgeCallNativeInternal('SecureStoreLoad', { key: key });
    };
    XamAppBridge.prototype.secureStoreSave = function (value, key) {
        if (key === void 0) { key = null; }
        return this.bridgeCallNativeInternal('SecureStoreSave', { key: key, value: value });
    };
    XamAppBridge.prototype.storeDeleteDocument = function (id) {
        return this.bridgeCallNativeInternal('StoreDeleteDocument', { id: id });
    };
    XamAppBridge.prototype.storeGetDocument = function (id) {
        return this.bridgeCallNativeInternal('StoreGetDocument', { id: id });
    };
    //// TODO there is no data her it seems
    XamAppBridge.prototype.storeGetDocumentList = function () {
        return this.bridgeCallNativeInternal('StoreGetDocumentList', null);
    };
    XamAppBridge.prototype.storeSaveDocument = function (document) {
        return this.bridgeCallNativeInternal('StoreSaveDocument', document);
    };
    XamAppBridge.debugEnabled = true;
    return XamAppBridge;
}());
exports.XamAppBridge = XamAppBridge;
exports.appBridge = new XamAppBridge();
window.AppBridge = exports.appBridge;
//# sourceMappingURL=app-bridge.js.map